import React from "react";

import Box from "@mui/material/Box";
import DialogContent from "@mui/material/DialogContent";

import ModalDialog, { ModalDialogHeader } from "@refere/ui-utils/ui/components/ModalDialog"

import { useHookstate } from "@hookstate/core";

import { globalState } from "../../../features/global-state";


const AvisoMaisDeDoisSegurosAtivos = () => {
    const simulacaoState = useHookstate(globalState.simulacao);
    const pageCertificadoState = useHookstate(globalState.pageCertificado);

    return (
        <ModalDialog
            isOpen={
                !!simulacaoState?.ehSeguradoComDoisSegurosAtivos?.get() && 
                !pageCertificadoState.dtHrPagamento?.get()
            } 
            sx={{
                "&& .MuiButtonBase-root":{
                    display: "none"
                }
            }}
            onClose={() => {}}
        >
            <ModalDialogHeader onClose={() => {}}>
                <Box minWidth="200px">
                    Aviso
                </Box>
            </ModalDialogHeader>
            <DialogContent dividers>
                O Proponente já tem dois Seguros Ativos Contratados.
            </DialogContent>
        </ModalDialog>
    );
}

export default AvisoMaisDeDoisSegurosAtivos;